const MIN_LENGTH = 8;
const MAX_LENGTH = 256;

/**
 * Returns the first validation error message for a password, or empty string if valid.
 * Rules: min 8 / max 256 chars, no spaces, at least one lower, upper, digit, and symbol (non-alphanumeric, non-space).
 */
export function getPasswordValidationError(password: string): string {
  if (password.length < MIN_LENGTH) {
    return 'Password must be at least 8 characters';
  }
  if (password.length > MAX_LENGTH) {
    return 'Password must be no more than 256 characters';
  }
  if (/\s/.test(password)) {
    return 'Password must not contain spaces';
  }
  if (!/[a-z]/.test(password)) {
    return 'Add at least one lowercase letter';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Add at least one uppercase letter';
  }
  if (!/\d/.test(password)) {
    return 'Add at least one number';
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return 'Add at least one special character (e.g. ! @ # - _)';
  }
  return '';
}

export const COGNITO_INVALID_PASSWORD_MESSAGE =
  "Password doesn't meet requirements. Check that it's at least 8 characters and includes letters, numbers, and a symbol.";
